export const AZIENDAREALTIME = 'AZIENDAREALTIME'